import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import DashboardAdmin from '../../components/views/admin/Dashboard'
import DashboardTeacher from '../../components/views/teacher/Dashboard'
import DashboardStudent from '../../components/views/student/Dashboard'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'
import { mayOpenAdminPage } from '../../shared/alumni'
import { isJmcTeacher } from '../../shared/miniCompanies'

function Dashboard(props) {
	if (mayOpenAdminPage(props.role, 'dashboard')) return <DashboardAdmin />
	// Eine Volksschul-Lehrkraft hat kein Dashboard: Es zeigt nur Junior
	// Companies. Ihr Einstieg sind die Unternehmen, also ihre JMC.
	else if (isJmcTeacher(props.role, props.profile)) return <Redirect to={TRoutes.COMPANIES} />
	else if (props.role === TRoles.TEACHER) return <DashboardTeacher />
	// Unterstuetzer:innen haben kein eigenes Dashboard - ihr Einstieg ist das
	// Profil. Ohne diesen Zweig bekaemen sie das Schueler-Dashboard, dessen
	// API-Aufrufe fuer die Rolle SUPPORTER mit 403 scheitern.
	else if (props.role === TRoles.SUPPORTER) return <Redirect to={TRoutes.SUPPORTER_PROFILE} />
	else return <DashboardStudent />
}

Dashboard.propTypes = {
	role: PropTypes.string.isRequired,
	profile: PropTypes.object
}

export default injectRole(Dashboard, state => ({ profile: state.user.profile }))
